import React from 'react'
import type { StructuredMaterialSpec } from '../types/mrpTypes'
import { formatSpecDisplay } from '../utils/mrpFormatters'

export interface MrpSpecBadgeProps {
  spec?: StructuredMaterialSpec | string | null
  className?: string
}

export function MrpSpecBadge({ spec, className = '' }: MrpSpecBadgeProps): React.ReactElement {
  const text = formatSpecDisplay(spec)

  if (text === '—') {
    return <span className="text-slate-400">—</span>
  }

  return (
    <span
      className={`inline-flex items-center gap-1 rounded bg-slate-100 px-2 py-0.5 text-xs font-mono text-slate-700 border border-slate-200 ${className}`}
      title={typeof spec === 'object' && spec ? JSON.stringify(spec, null, 2) : text}
    >
      {text}
    </span>
  )
}
